// extracted by mini-css-extract-plugin
module.exports = {"Container":"AccountInvitation_Container__vEsYI","GlobalError":"AccountInvitation_GlobalError__3a5KI"};